import { Input } from '@chakra-ui/react';
import { useEffect } from 'react';

import {
	defineBorderColorValue,
	defineInputValue,
} from './constants/inputsControl';
import { setInputsWithLocalstorage } from './constants/setInputsWithLocalstorage';
import { IInputs } from './models/InputsModel';

export const InputNumber = ({ ...others }: IInputs) => {
	const {
		dataTest,
		column,
		handleOnChange,
		inputValue,
		name,
		setInputValue,
		validation,
		localStorageValue,
	} = others;

	useEffect(() => {
		if (localStorageValue.length > 0) {
			setInputsWithLocalstorage({
				column,
				localStorageValue,
				name,
				setInputValue,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Input
			data-test={dataTest}
			type={'number'}
			borderRadius={'10px'}
			borderColor={defineBorderColorValue({
				name,
				validation,
			})}
			focusBorderColor='#e2e8f0'
			h={'3em'}
			fontSize={'12px'}
			color={'blue.800'}
			placeholder={'1.000,00'}
			name={name}
			onChange={event => handleOnChange(event)}
			value={defineInputValue({
				name,
				inputValue,
			})}
		/>
	);
};
